import { FC, PropsWithChildren, Fragment } from 'react';
import { MapToPropsFn } from './types';

type Props<T, U> = {
  data: T[];
  mapToProps: MapToPropsFn<T, U>;
  Component: FC<U>;
  RootComponent?: FC<PropsWithChildren>;
};

export const Layout = <T, U>({
  data,
  Component,
  mapToProps,
  RootComponent = Fragment,
}: Props<T, U>) => (
  <RootComponent>
    {data.map((value, index, array) => (
      <Component key={index} {...mapToProps(value, index, array)} />
    ))}
  </RootComponent>
);
